import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AccountService, AppConfigService } from "@app/core";
import { PermissionTypeDto } from "clearline-api";
import { UserPermissionService } from "clearline-common";
import { RoleTypes } from "core-kit";

@Component({
  selector: "app-access-denied",
  templateUrl: "./access-denied.component.html",
  styleUrls: ["./access-denied.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessDeniedComponent implements OnInit {
  isManager = false;
  isLocationManager = false;
  hasDashboardAccess = false;
  hasCmcAccess = false;

  constructor(
    private router: Router,
    private accountSvc: AccountService,
    private configSvc: AppConfigService,
    private userPermissionService: UserPermissionService
  ) {}

  ngOnInit(): void {
    this.isManager = this.accountSvc.isUserInRole(RoleTypes.Manager);
    this.isLocationManager = this.accountSvc.isUserInRole(RoleTypes.LocationManager);

    const isAdminLevel = this.accountSvc.isUserRequireMinRole(RoleTypes.PartnerAdmin);

    this.hasDashboardAccess = isAdminLevel || (this.userPermissionService.hasPermission(PermissionTypeDto.Dashboard) && this.isManager);
    this.hasCmcAccess = !isAdminLevel && this.userPermissionService.hasPermission(PermissionTypeDto.Cmc) && !this.isManager;
  }

  goToDashboard() {
    this.router.navigate(["/"]);
  }

  goToCmc() {
    const cmcUrl = this.configSvc.appData.marketingCenterUrl;
    location.href = cmcUrl;
  }
}
